export class CapabilityNotEnabledError extends Error {
  public capability: string;
  public statusCode: number;

  constructor(capability: string, message?: string) {
    super(message ?? `${capability} capability is not enabled for this workspace`);
    this.name = 'CapabilityNotEnabledError';
    this.capability = capability;
    this.statusCode = 412;

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CapabilityNotEnabledError);
    } else {
      Object.defineProperty(this, 'stack', {
        enumerable: false,
        writable: false,
        value: new Error(this.message).stack,
      });
    }
  }
}
